module.exports = __webpack_public_path__ + "img/breast-feeding_x2.e1496e5f.png";